import axios from '../axios'
// 创建工资条

// 登录
export const login = data => {
    return axios({
        url: '/login.html',
        method: 'post',
        data
    })
};

// 获取验证码
export const getCode = (params) => {
    return axios({
        url: '/salary/account/getVerificationCode',
        method: 'get',
        params
    })
};

//注册
export const registerUser = data => {
    return axios({
        url: '/salary/account/registerUser',
        method: 'post',
        data
    })
};

//修改密码
export const updatePassWord = data => {
    return axios({
        url: '/salary/account/updatePassWord',
        method: 'post',
        data
    })
};
// 修改密码前，获取第三方登陆者信息
export const getUserInfo = data => {
    return axios({
        url: '/CompanySalaryOrder/getUserInfo',
        method: 'post',
        data
    })
};

// 初始化密码
export const resetPassWord = data => {
    return axios({
        url: '/salary/account/resetPassWord',
        method: 'post',
        data
    })
};
// 初始化密码中的查询人员信息
export const retrieveUser = data => {
    return axios({
        url: '/salary/account/retrieveUser',
        method: 'post',
        data
    })
};





// WEBPACK FOOTER //
// ./src/http/moudules/login.js